import React, { useState } from "react";
import { TextField, MenuItem, Button, IconButton } from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import CloseIcon from '@mui/icons-material/Close';


const conditionOptions = [
  { label: "is equal to", value: "===" },
  { label: "is not equal to", value: "!==" },
  { label: "is greater than", value: ">" },
  { label: "is less than", value: "<" },
  { label: "is greater than or equal to", value: ">=" },
  { label: "is less than or equal to", value: "<=" },
];

const Condition = ({ index, condition, onDelete, onChange,showOperator }) => {
  return (
    <>
    {showOperator && (
      <Grid marginBottom={3} sx={{ display: "flex", alignItems: "center" }}>
        <TextField
          select
          size="medium"
          value={condition.logicOperator || ""}
          onChange={(e) => onChange(index, "logicOperator", e.target.value)}
          sx={{ marginRight: 2, width: "150px" }}
        >
          <MenuItem value="AND">AND</MenuItem>
          <MenuItem value="OR">OR</MenuItem>
        </TextField>
      </Grid>
    )}
    <Grid sx={{display:"flex"}} marginBottom={3}>
  <TextField
  placeholder="value 1"
    size="medium"
    value={condition.value1}
    onChange={(e) => onChange(index, "value1", e.target.value)}
  />
  <TextField
    select
    size="medium"
    value={condition.operator}
    onChange={(e) => onChange(index, "operator", e.target.value)}
  >
    {conditionOptions.map((option) => (
      <MenuItem key={option.value} value={option.value}>
        {option.label}
      </MenuItem>
    ))}
  </TextField>
  <TextField
    placeholder="Value 2"
    size="medium"
    value={condition.value2}
    onChange={(e) => onChange(index, "value2", e.target.value)}
  />
  <IconButton onClick={() => onDelete(index)} color="error" sx={{border:"none"}}>
  <CloseIcon />
  </IconButton>
</Grid>
</>

  );
};



export default Condition;
